import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DefaultOptionType } from "antd/lib/select";
import { graphql } from "~/gql";
import { GroupedEntityType } from "~/gql/graphql";

export const GROUP_ITEM_CHILD_FRAGMENT = graphql(/* GraphQL */ `
  fragment GroupItemChildFragment on GroupItem {
    id
    name
    description
    parentId
    entityType
    parent {
      id
      name
      description
    }
    outputDesigns {
      id
      title
      active
    }
  }
`);

export const GROUP_ITEM_FRAGMENT = graphql(/* GraphQL */ `
  fragment GroupItemFragment on GroupItem {
    id
    name
    entityType
    description
    parentId
    outputDesigns {
      id
      title
      active
    }
    children {
      ...GroupItemChildFragment
      children {
        ...GroupItemChildFragment
        children {
          ...GroupItemChildFragment
          children {
            ...GroupItemChildFragment
          }
        }
      }
    }
  }
`);

export const GET_GROUP_ITEMS = graphql(/* GraphQL */ `
  query GroupItems($groupedEntityType: String!) {
    groupItems(groupedEntityType: $groupedEntityType) {
      ...GroupItemFragment
    }
  }
`);

export const CREATE_GROUP_ITEM = graphql(/* GraphQL */ `
  mutation CreateGroupItem($createInput: CreateGroupItem!) {
    createGroupItem(createInput: $createInput) {
      id
      name
      description
      entityType
      parentId
      parent {
        id
        name
        description
      }
    }
  }
`);

export const UPDATE_GROUP_ITEM = graphql(/* GraphQL */ `
  mutation UpdateGroupItem($id: Float!, $updateInput: GroupItemUpdateInput!) {
    updateGroupItem(id: $id, updateInput: $updateInput) {
      id
      name
      description
      entityType
      parentId
      parent {
        id
        name
        description
      }
    }
  }
`);

export const useCreateGroupItem = () => {
  const [createGroupItem] = useMutation(CREATE_GROUP_ITEM);

  return {
    createGroupItem,
  };
};

type GroupItem = {
  id: number;
  name: string;
  parentId?: number | null;
  children?: GroupItem[] | null;
};

export const mapGroupItemToCascade = (items: GroupItem[]): DefaultOptionType[] => {
  return items.map((item) => ({
    value: item.id,
    label: item.name,
    children: mapGroupItemToCascade(item.children || []),
  }));
};

export const useGroupItems = (groupedEntityType: GroupedEntityType) => {
  const { data, loading, error } = useQuery(GET_GROUP_ITEMS, {
    variables: { groupedEntityType },
  });

  const groupedForCascade = mapGroupItemToCascade(data?.groupItems || []);

  return {
    data,
    loading,
    error,
    groupedForCascade,
  };
};

export const useGroupItemsLazy = () => {
  const [getGroupItems, { data, error, loading }] = useLazyQuery(GET_GROUP_ITEMS);

  const groupedForCascade = mapGroupItemToCascade(data?.groupItems || []);

  return {
    data,
    loading,
    loadgroupItems: getGroupItems,
    error,
    groupedForCascade,
  };
};
